import { render } from "./HistoricoPage.vue?vue&type=template&id=65d332a6&scoped=true"
import script from "./HistoricoPage.vue?vue&type=script&lang=js"
export * from "./HistoricoPage.vue?vue&type=script&lang=js"

import "./HistoricoPage.vue?vue&type=style&index=0&id=65d332a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d332a6"]])

export default __exports__